import axios from 'axios';
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { myPlanHistory, myPlanPaymentHistory, paymentList, getPaymentStatus, planAssignToProvider, exportExcelData, listClient, listBranches, listService, listStaff, listCategory } from '../../../Context/api';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik'

const UsePlanHistory = () => {
    const [show, setShow] = useState(false)
    const [planData, setPlanData] = useState([])
    const [paymentData, setPaymentData] = useState([])
    const [myPaymentData, setMyPaymentData] = useState([])
    const [count, setCount] = useState('')
    const [page, setPage] = useState(1)
    const [reset, setReset] = useState(false);
    const PER_PAGE = 10
    const [paymentDetailsModal, setPaymentDetailsModal] = useState({ open: false, data: {} })
    const [planAssignModal, setPlanAssignModal] = useState({ open: false, data: {} })
    // const [paymentDetailsData, setPaymentDetailsData] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const { id } = useParams()
    const [tab, setTab] = useState(1)

    // View 
    const [nestedtab, setNestedTab] = useState({
        tab: 1,
        show: false,
        nestedPage: 1,
        nestedCount: '',
        serviceShow: false
    })
    const [data, setData] = useState({
        branchData: [],
        clientData: [],
        serviceCategory: [],
        servicesData: [],
        teamData: [],
        branchId: '',
        categoryId: ''
    });
    const [filter, setFilter] = useState({
        startDate: null,
        endDate: null,
        type: 'RAZORPAY',
        pageCount: 10,
    })



    useEffect(() => {
        if (tab === 1) {
            branches()
        }
        else if (tab === 2) {
            clients()
        }
        else if (tab === 3) {
            planHistory()
        }
        else {
            myPaymentsList()
        }
    }, [page, tab,reset])

    useEffect(() => {
        if (nestedtab?.serviceShow) {
            services()
        }
        else {
            if (nestedtab.tab === 1) {
                serviceCategoryList()
            }
            else {
                teamList()
            }
        }

    }, [nestedtab.nestedPage, data.branchId, nestedtab.tab, data.categoryId])

    const planHistory = () => {
        setSpinner(true)
        axios.post(myPlanHistory(), { userId: id, page: page, count: PER_PAGE }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setPlanData(resp.data)
                setCount(resp.data.totalCount);
                setSpinner(false)
            }
            else {
                setSpinner(false)

            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const myPaymentsList = () => {
        const payload = {
            userId: id,
            page: page,
            count: filter?.pageCount,
            type:filter?.type,
            startDate:filter?.startDate,
            endDate: filter?.endDate
        }
        setSpinner(true)
        axios.post(paymentList(), { ...payload }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setMyPaymentData(resp.data)
                setCount(resp.data.totalCount);
                setSpinner(false)
            }
            else {
                setSpinner(false)
                setMyPaymentData([])

            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const assignPlan = () => {
        const payload = {
            assignPlanId: planAssignModal?.data?._id,
        }
        setSpinner(true)
        axios.post(planAssignToProvider(), { ...payload }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp?.data?.message)
                setSpinner(false)
                setPlanAssignModal({ open: false, data: {} })
                planHistory()
            }
            else {
                setSpinner(false)
                toast.error(resp?.data?.message)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const getMyPayments = (item) => {
        const payload = {
            paymentLink: item?.payLink,
            referenceId: item?.referenceId
        }
        setSpinner(true)
        axios.post(getPaymentStatus(), { ...payload }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setPaymentDetailsModal((pre) => ({ ...pre, open: true, data: resp.data.data }))
                setSpinner(false)
            }
            else {
                setSpinner(false)

            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const formik = useFormik({
        initialValues: {
            startDate: '',
            endDate: '',
            features: [
                {
                    keyName: '',
                    keyValue: '',
                    constName: '',
                },
            ],
            validity: '',
            keyName: '',
            keyValue: '',
            constName: '',
            addOns: { chat: false, multipleServiceBooking: false, staffLogin: false, emailRemainder: false, ticketSupport: false, insight: false },
            addOnsInput: { chat: 0, multipleServiceBooking: 0, staffLogin: 0, emailRemainder: 0, ticketSupport: 0, insight: 0 },
        },
        onSubmit: (values) => {
        },
    });
    const view = (resp) => {
        let data = resp?.features?.map((item) => (
            { constName: item?.constName, keyName: item?.keyName, keyValue: item?.keyValue }
        ))
        formik.setFieldValue('features', data)
        formik.setFieldValue('startDate', resp.startDate)
        formik.setFieldValue('endDate', resp.endDate)
        formik.setFieldValue('validity', resp.validity)
        resp.addons?.map((item) => {
            if (item.constName === 'CHAT') {
                formik.setFieldValue('addOns.chat', item.keyValue)
                formik.setFieldValue('addOnsInput.chat', item.price)
            }
            if (item.constName === 'STAFFLOGIN') {
                formik.setFieldValue('addOns.staffLogin', item.keyValue)
                formik.setFieldValue('addOnsInput.staffLogin', item.price)
            }
            if (item.constName === 'EMAILREMAINDER') {
                formik.setFieldValue('addOns.emailRemainder', item.keyValue)
                formik.setFieldValue('addOnsInput.emailRemainder', item.price)
            }
            if (item.constName === 'INSIGHT') {
                formik.setFieldValue('addOns.insight', item.keyValue)
                formik.setFieldValue('addOnsInput.insight', item.price)
            }

        })
    }
    const planPaymentHistory = (item) => {
        const payload = {
            userId: id,
            planId: item?._id
        }
        setSpinner(true)
        axios.post(myPlanPaymentHistory(), { ...payload }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setSpinner(false)
            }
            else {
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    //View
    const exportData = (type) => {
        setSpinner(true)
        axios.post(exportExcelData(), { providerId: id, type: type, categoryId: data?.categoryId, branchId: data?.branchId }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setSpinner(false)
                window.open(resp.data.data.fileName)
            }
            else {
                setSpinner(false)

            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const branches = () => {
        setSpinner(true)
        axios.post(listBranches(), { providerId: id, page: page, count: PER_PAGE }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setData((pre) => ({
                    ...pre,
                    branchData: resp.data.data
                }));
                setCount(resp.data.totalCount);
                setSpinner(false)
            }
            else {
                setSpinner(false)
                setData((pre) => ({
                    ...pre,
                    branchData: []
                }));

            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const clients = () => {
        setSpinner(true)
        axios.post(listClient(), { providerId: id, page: page, count: PER_PAGE }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setData((pre) => ({ ...pre, clientData: resp.data }))
                setCount(resp.data.totalCount);
                setSpinner(false)
            }
            else {
                setSpinner(false)
                setData((pre) => ({ ...pre, clientData: [] }))

            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const serviceCategoryList = (branchId) => {
        setSpinner(true)
        axios.post(listCategory(), { providerId: id, page: nestedtab.nestedPage, count: PER_PAGE, branchId: branchId || data?.branchId }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setData((pre) => ({ ...pre, serviceCategory: resp.data }))
                setNestedTab((pre) => ({ ...pre, nestedCount: resp.data.totalCount }))
                setSpinner(false)
            }
            else {
                setSpinner(false)
                setData((pre) => ({ ...pre, serviceCategory: [] }))

            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const teamList = () => {
        setSpinner(true)
        axios.post(listStaff(), { providerId: id, page: nestedtab.nestedPage, count: PER_PAGE, branchId: data?.branchId }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setData((pre) => ({ ...pre, teamData: resp.data }))
                setNestedTab((pre) => ({ ...pre, nestedCount: resp.data.totalCount }))
                setSpinner(false)
            }
            else {
                setSpinner(false)
                setData((pre) => ({ ...pre, teamData: [] }))

            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const services = () => {
        setSpinner(true)
        axios.post(listService(), { providerId: id, page: nestedtab.nestedPage, count: PER_PAGE, categoryId: data?.categoryId }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setData((pre) => ({ ...pre, servicesData: resp.data }))
                setNestedTab((pre) => ({ ...pre, nestedCount: resp.data.totalCount }))
                setSpinner(false)
            }
            else {
                setSpinner(false)
                setData((pre) => ({ ...pre, servicesData: [] }))

            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilter((preProps) => ({
            ...preProps,
            [name]: value
        }))
    }
    const clear = () => {
        setPage(1)
        setFilter({
            startDate: null,
            endDate: null,
            type: 'RAZORPAY',
            pageCount:10
        })
        setReset((prev) => !prev);

    }
    return {
        view,
        clear,
        setTab,
        setPage,
        setShow,
        setData,
        setCount,
        setSpinner,
        exportData,
        assignPlan,
        setPlanData,
        myPaymentsList,
        planHistory,
        setNestedTab,
        handleChange,
        getMyPayments,
        setPaymentData,
        setPlanAssignModal,
        planPaymentHistory,
        setPaymentDetailsModal,
        paymentDetailsModal,
        planAssignModal,
        myPaymentData,
        paymentData,
        nestedtab,
        planData,
        PER_PAGE,
        spinner,
        formik,
        count,
        show,
        page,
        tab,
        data,
        filter


    }
}

export default UsePlanHistory